import React,{ useState, useEffect } from 'react';
import PartenaireService from "../../service/PartenaireSevice";
import {urlDirectus} from "../../config/Globals";
export const Partenaires = () => {

    const[partenaires, setPartenaires] = useState([]);
    const[loadingPartenaires, setLoadingPartenaires] = useState(1);
    const fetchPartenaires = async() => {
        try{
            const data = await PartenaireService.findAll();
            setPartenaires(data);
            setLoadingPartenaires(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchPartenaires();
    }, []);

    return (
        <>
            <section id="partenaires" className="bg-white py-md-5">
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-xl-10 d-flex flex-column align-items-center">
                            <h2 className="display-6 fw-sb text-center mt-3">Nos partenaires</h2>
                            <ul className="list-unstyled d-flex flex-wrap justify-content-center align-items-center gap-5 pt-5 m-0">
                                {
                                    partenaires.map((partenaire, index) => {
                                       return  (
                                           <li>
                                               <a href={partenaire.lien} target="_blank" rel="noopener">
                                                   <img src={urlDirectus+"assets/"+partenaire.logo} alt={partenaire.nom} />
                                               </a>
                                           </li>
                                       )
                                    })
                                }
                            </ul>
                            <a className="btn btn-outline-custom mx-auto mt-5" href="/partenaires">Voir tous les partenaires</a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}